// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navbar_nav__35H4S"};